/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * The RouteOnMap view allows you to display a route on the map.
 * 
 * This widget requires route data to work correcly. For more information please refer to our 
 * <a href="https://developer.tomtom.com/maps-sdk-web/functional-examples#routing_ab_instructions" target="_blank">
 * Routing example</a>.
 *
 * @class RouteOnMap
 * @namespace L
 * @extends L.LayerGroup
 * @module Widgets
 * @uses L.Evented
 * @constructor
 * @param {Object} [options] Options to be passed to the routing view
 * @param {Object} [options.generalMarker] General marker options that applies on all markers
 * @param {L.Icon} [options.generalMarker.icon=default] Default icon for every marker
 * @param {Boolean} [options.generalMarker.draggable=false] Determines default drag behaviour for every marker
 * @param {Object} [options.startMarker] Marker options for starting marker
 * @param {L.Icon} [options.startMarker.icon=default] Icon for start marker
 * @param {Boolean} [options.startMarker.draggable=false] Determines whether start marker should be draggable
 * @param {Object} [options.waypointMarker] Marker options for markers between start and end points
 * @param {L.Icon} [options.waypointMarker.icon=default] Icon for markers between start and end points
 * @param {Boolean} [options.waypointMarker.draggable=false] Determines whether start marker should be draggable
 * @param {Object} [options.endMarker] Marker options for end marker
 * @param {L.Icon} [options.endMarker.icon=default] Icon for end marker
 * @param {Boolean} [options.endMarker.draggable=false] Determines whether end marker should be draggable
 * @param {"topleft"|"topright"|"bottomleft"|"bottomright"} [options.position="topleft"]
 * @param {Object} [options.routeStyle={color: '#00d7ff', opacity: 0.8}] A style object used for drawing the
 *     polyline route. All the <a href="https://leafletjs.com/reference-${leaflet.version}.html#path">L.Path</a>
 *     options are accepted.
 * @param {Object[]} [options.alternativeStyles=[{color: '#ff00d2', opacity: 0.8}, {color: '#b922ff',opacity: 0.8}]]
 * If the option to display alternatives is passed to the service options then there is a need to pass array of
 *     <a href="https://leafletjs.com/reference-${leaflet.version}.html#path">L.Path</a> style's options for each
 *     alternative route
 * @param {Number} [options.routingDelay=1000] Determines the time in milliseconds that within routing service will
 *     be called. Used when user is dragging a marker
 * @param {Function} [options.onEachFeature] A function that will be called for each feature, it takes feature
 *     and layer as the attributes. Can be used in example to bind popup to the route
 * @param {Object} [options.serviceOptions] Options to be passed to the routing service. For details check
 *     routingService documentation
 *
 * @example
 * ```javascript
 * var routeOnMapView = new L.RouteOnMap({
 *   generalMarker: {
 *     draggable: true
 *   },
 *   startMarker: {
 *     background: {
 *       iconSize: [30, 36],
 *       iconAnchor: [15, 36],
 *       icon: 'marker'
 *     },
 *     icon: {
 *       iconSize: [30, 30],
 *       iconAnchor: [0, 0],
 *       icon: 'flag-white'
 *     },
 *   },
 *   waypointMarker: {
 *     icon: L.icon({
 *       iconUrl: 'waypoint.png',
 *       iconSize: [30, 30],
 *       iconAnchor: [15, 15]
 *     })
 *   },
 *   endMarker: {
 *     icon: L.icon({
 *       iconUrl: 'end.png',
 *       iconSize: [30, 30],
 *       iconAnchor: [15, 15]
 *     })
 *   },
 *   routeStyle: {
 *     color: "#00d7ff",
 *     opacity: 0.8
 *   }
 * });
 * routeOnMapView.addTo(map);
 * ```
 */
/* jshint nomen:false */
define(['display/map', 'services/routing/routing', 'services/reverseGeocode/reverseGeocode',
    'services/converters', 'services/utils'
],
function(L, routingService, reverseGeocodeService, converters, utils) {
    'use strict';

    var EVENTS = {
        MarkerDragEnd: 'markerDragEnd',
        Draw: 'draw',
        RouteChanged: 'routeChanged',
        RouteNotFound: 'routeNotFound'
    };

    /**
     * @param {String} [type]
     * @return {Object}
     */
    function createMarkerIcon(type) {
        var generalMarkerIcon = {
            background: {
                iconSize: L.Browser.retina ? [34, 34] : [20, 20],
                iconAnchor: L.Browser.retina ? [17, 17] : [10, 10],
                icon: 'icon-shield'
            },
            icon: {
                iconSize: L.Browser.retina ? [30, 30] : [18, 18],
                iconAnchor: L.Browser.retina ? [-2, -2] : [-1, -1],
                icon: 'icon-flag-white'
            }
        };
        if (type === 'start') {
            generalMarkerIcon.icon.icon = 'icon-start-white';
        } else if (type === 'end') {
            generalMarkerIcon.icon.icon = 'icon-end-white';
        }
        return generalMarkerIcon;
    }

    function getRouteStyle(style) {
        var styleIndex = 0;
        return function() {
            styleIndex += 1;
            return style[styleIndex % style.length] || style;
        };
    }

    function convertPoints(points) {
        var point,
            i;
        for (i = 0; i < points.length; i++) {
            point = points[i];
            points[i] = point ? L.latLng(converters.point(point).split(',')) : undefined;
        }
        return points;
    }

    function getIconOptions(points, index, options) {
        var iconOptions = utils.clone(options.generalMarker);
        if (index === 0) {
            utils.addFields(options.startMarker, iconOptions);
            iconOptions.icon = options.startMarker.icon;
        } else if (index === points.length - 1) {
            utils.addFields(options.endMarker, iconOptions);
            iconOptions.icon = options.endMarker.icon;
        } else {
            utils.addFields(options.waypointMarker, iconOptions);
            iconOptions.icon = options.waypointMarker.icon;
        }
        if (options.generalMarker.zIndexOffset) {
            iconOptions.zIndexOffset = options.generalMarker.zIndexOffset;
        }
        return iconOptions;
    }

    function onDragListener(points, e, markers, callback) {
        var index = markers.indexOf(e.target);
        points[index] = e.target.getLatLng();
        callback.call(this, points, index);
    }

    function getAllFilledLocations(points) {
        var filledLocations = [],
            i;
        for (i = 0; i < points.length; i++) {
            if (points[i] !== undefined) {
                filledLocations.push(points[i]);
            }
        }
        return filledLocations;
    }

    function isAtLeastPairOfPoints(points) {
        return points && points.length && points.length > 1;
    }

    L.RouteOnMap = L.LayerGroup.extend({
        includes: L.Evented.prototype,
        statics: {
            Events: EVENTS
        },
        options: {
            generalMarker: {
                icon: L.svgIcon(createMarkerIcon()),
                draggable: false
            },
            startMarker: {
                icon: L.svgIcon(createMarkerIcon('start')),
                draggable: false
            },
            waypointMarker: {
                icon: L.svgIcon(createMarkerIcon('waypoint')),
                draggable: false
            },
            endMarker: {
                icon: L.svgIcon(createMarkerIcon('end')),
                draggable: false
            },
            position: 'topleft',
            routeStyle: {
                color: '#00d7ff',
                opacity: 0.8
            },
            alternativeStyles: [
                {
                    color: '#ff00d2',
                    opacity: 0.8
                },
                {
                    color: '#b922ff',
                    opacity: 0.8
                }
            ],
            routingDelay: 1000,
            serviceOptions: {}
        },

        initialize: function(options) {
            L.Util.setOptions(this, options);
        },

        /**
         * Method used to create markers on a map, basing on given points.
         *
         * @method createMarkers
         * @param {Object[]} points List of points to create markers onto
         */
        createMarkers: function(points) {
            var that = this,
                markers = [],
                iconOptions,
                marker,
                point,
                i;

            var dragEndHandler = function(event) {
                if (!isAtLeastPairOfPoints(points)) {
                    return;
                }
                onDragListener.call(that, points, event, markers, that.onDragEnd);
            };

            var dragHandler = function(event) {
                if (!isAtLeastPairOfPoints(points)) {
                    return;
                }
                onDragListener.call(that, points, event, markers, that.onDrag);
            };

            for (i = 0; i < points.length; i++) {
                point = points[i];

                if (point !== undefined) {
                    iconOptions = getIconOptions(points, i, this.options);
                    marker = L.marker(point, iconOptions);
                    markers.push(marker);

                    if (iconOptions.draggable) {
                        marker.on('dragend', dragEndHandler);
                        marker.on('drag', dragHandler);
                    }
                }
            }

            delete this.markers;
            if (markers.length > 0) {
                this.markers = L.featureGroup(markers);
                this.markers.addTo(this._map);
            }
        },

        /**
         * Draws a route on the map between given points.
         *
         * This method executes TomTom Routing Service to get a route.
         * If a route is found, it will draws it on the map. If not, a proper notification will be show.
         *
         * @method createRoute
         * @param {String[]|String} points List of points to create a route between.
         * The format expected is:
         *  - ["52.37245,4.89406", "51.37245,5.89406"]
         *  - "52.37245,4.89406:51.37245,5.89406"
         *
         * Read the Routing Service documentation to get more information about this property format options.
         */
        createRoute: function(points) {
            var that = this;
            this.options.serviceOptions.locations = points;
            routingService(this.options.serviceOptions).go().then(function(routeGeoJson) {
                if (routeGeoJson.features.length > 0) {
                    that.drawRouteWithGeoJson(routeGeoJson);
                } else {
                    that.clearRoute();
                    L.messageBox({
                        closeAfter: 1500
                    }).openOn(that._map)
                        .setContent('Could not find a route. <br/>You might trying to route between continents.');
                }
            }).catch(function(reason) {
                that.fire(that.Events.RouteNotFound, reason);
            });
        },

        /**
         * Method executed when the user drag a marker.
         *
         * Allows to look for routes while dragging a marker and within delay
         * equal to the value passed in the option `routingDelay`.
         *
         * @method onDrag
         * @param {String[]|String} points List of points to create a route within.
         * This value will be passed to {{#crossLink "L.RouteOnMap/createRoute:method"}}{{/crossLink}}
         * for create the new route.
         */
        onDrag: function(points) {
            var that = this;
            if (this.recalculateRoute === true) {
                setTimeout(function() {
                    that.clearRoute();
                    that.createRoute(points);
                    that.recalculateRoute = true;
                }, this.options.routingDelay);
                this.recalculateRoute = false;
            }
        },

        /**
         * Method executed when the user drops a marker (equal to dragEnd event).
         *
         * Redraws route according to given points
         * and executes TomTom Reverse Geocode Service to get human-readable location when marker was dropped. That
         * fires the {{#crossLink "L.RouteOnMap/L.RouteOnMap.Events.MarkerDragEnd:event"}}{{/crossLink}} event with
         * service's call result and index of a marker.
         *
         * @method onDragEnd
         * @param {String[]|String} points List of points.
         * The expected format is:
         *  - ["52.37245,4.89406", "51.37245,5.89406"]
         *  - "52.37245,4.89406:51.37245,5.89406"
         * @param {Number} index Index of the marker that was dropped
         */
        onDragEnd: function(points, index) {
            var that = this;
            this.clearRoute();
            this.createRoute(points);
            this.once(this.Events.RouteChanged, this.fitMapBoundsToRoute, this);

            reverseGeocodeService().position(points[index]).go().then(function(result) {
                that.fire(that.Events.MarkerDragEnd, {
                    object: result,
                    markerIndex: index
                });
            });
        },

        /**
         * Method that removes all markers.
         *
         * @method clearMarkers
         */
        clearMarkers: function() {
            if (this.markers) {
                this.markers.clearLayers();
            }
            this.markers = undefined;
        },

        /**
         * Method that clears shown route.
         *
         * @method clearMarkers
         */
        clearRoute: function() {
            if (this.routeOnMapLayer) {
                this._map.removeLayer(this.routeOnMapLayer);
            }
            this.routeOnMapLayer = undefined;
        },

        /**
         * Method that fits map to the drawn route.
         *
         * @method fitMapBoundsToRoute
         */
        fitMapBoundsToRoute: function() {
            var areaToBoundTo = this.routeOnMapLayer || this.markers;
            if (areaToBoundTo) {
                this._map.fitBounds(areaToBoundTo.getBounds(), {
                    padding: [5, 5]
                });
            }
        },

        /**
         * Method that draws a route basing on a passed geoJson. Fires the
         * {{#crossLink "L.RouteOnMap/L.RouteOnMap.Events.RouteChanged:event"}}{{/crossLink}} event.
         *
         * @method drawRouteWithGeoJson
         * @param {Object} geoJson Represents geoJson data of a route
         */
        drawRouteWithGeoJson: function(geoJson) {
            this.clearRoute();
            this.routeOnMapLayer = L.geoJson(geoJson, {
                onEachFeature: this.options.onEachFeature,
                style: getRouteStyle(this.options.serviceOptions.maxAlternatives > 0 ?
                    this.options.alternativeStyles.concat([this.options.routeStyle]) : this.options.routeStyle)
            });
            this._map.addLayer(this.routeOnMapLayer);
            this.fire(this.Events.RouteChanged, {
                object: geoJson.features[0].properties.summary,
                instructions: geoJson.features[0].properties.guidance,
                geoJson: geoJson
            });
        },

        /**
         * Method that takes care of redrawing markers and a route.
         *
         * @method drawRoute
         * @param {String[]|String} points List of points to draw a route between.
         * The format expected is:
         *  - ["52.37245,4.89406", "51.37245,5.89406"]
         *  - "52.37245,4.89406:51.37245,5.89406"
         */
        drawRoute: function(points) {
            this.clear();
            this.recalculateRoute = true;
            this.createMarkers(points);

            if (points.length >= 2) {
                this.createRoute(points);
            }
        },

        /**
         * The method to draw a route between two or more points.
         *
         * @method draw
         * @param {Object[]} points Array of geographical locations that between route will be drawn. There are
         *     multiple formats supported (see more at e.g. _Search_ page in _center_ method). This method also
         *     fires the {{#crossLink "L.RouteOnMap/L.RouteOnMap.Events.Draw:event"}}{{/crossLink}} event that
         *     announces that route is drawn.
         * @example
         * ```javascript
         * var startPoint = {lat: 49.29917, lon: 19.94902};
         * var waypoint = {lat: 42.25917, lon: 19.98902};
         * var endPoint = {lat: 52.23498, lon: 21.00849};
         * var points = [startPoint, waypoint, endPoint];
         * var routeOnMapView = (new L.RouteOnMap()).addTo(map);
         * routeOnMapView.draw(points);
         * ```
         */
        draw: function(points) {
            points = convertPoints(points);
            points = getAllFilledLocations(points);
            this.drawRoute(points);
            this.fitMapBoundsToRoute();
            this.once(this.Events.RouteChanged, this.fitMapBoundsToRoute, this);
            this.fire(this.Events.Draw, {});
        },

        /**
         * The method to clear a route and markers.
         *
         * @method clear
         * @example
         * ```javascript
         * var routeOnMapView = (new L.RouteOnMap(optionsForRouteOnMapView)).addTo(map);
         * routeOnMapView.clear();
         * ```
         */
        clear: function() {
            this.clearMarkers();
            this.clearRoute();
        },

        /**
         * Event that is fired after dropping the marker. Contains information about marker's position.
         *
         * @event MarkerDragEnd
         * @param {Object} object Information of dropped marker's position (got from reverse geocode service)
         * @param {Number} markerIndex Index of the marker on a map
         * @param {String} [type="markerDragEnd"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var routeOnMapView = routeOnMap().addTo(map);
         * routeOnMapView.on(L.RouteOnMap.Events.MarkerDragEnd, function(eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired after drawing a route on a map.
         *
         * @event Draw
         * @param {String} [type="draw"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var routeOnMapView = (new L.RouteOnMap()).addTo(map);
         * routeOnMapView.on(L.RouteOnMap.Events.Draw, function(eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        /**
         * Event that is fired when route was changed.
         *
         * @event RouteChanged
         * @param {Object} object Route summary that contains arrival time, departure time, route length, traffic
         *      and travel time.
         * @param {String} [type="routeChanged"] Event's name
         * @param {Element} target Event's target
         *
         * @example
         * ```javascript
         * var routeOnMapView = (new L.RouteOnMap()).addTo(map);
         * routeOnMapView.on(L.RouteOnMap.Events.RouteChanged, function(eventObject) {
         *      console.log(eventObject);
         * });
         * ```
         */
        Events: EVENTS
    });

    return function(options) {
        var routeOnMap = new L.RouteOnMap(options);
        utils.addDeprecatedProperty(routeOnMap, 'Event', 'Events');
        return routeOnMap;
    };
});



// WEBPACK FOOTER //
// ./widgets/views/routeOnMap.js